// extracted by mini-css-extract-plugin
export var bodyRow = "_dp-d";
export var cardColumns = "_dp-e";
export var ellipsesOverflow = "_dp-2";
export var flatBottomCorners = "_dp-3";
export var flatTopCorners = "_dp-4";
export var headerActionsDropdown = "_dp-f";
export var headerBottomRow = "_dp-c";
export var headerTopRow = "_dp-b";
export var orderDetailsWrapper = "_dp-0";
export var orderInfoContainer = "_dp-1";
export var productDetails = "_dp-9";
export var productImage = "_dp-5";
export var responsiveTable = "_dp-8";
export var shipmentContainer = "_dp-a";
export var tableBottomLeft = "_dp-6";
export var tableBottomRight = "_dp-7";
export var trackingLink = "_dp-g";